/* Send the saved cart to Shopify's official checkout; never inject accelerated wallets into the product page. */
(() => {
  const versions = new WeakMap();
  const reset = root => {
    versions.set(root, (versions.get(root) || 0) + 1);
    const wallet = root.querySelector('[data-snowman-wallet]');
    if (!wallet) return;
    const button = wallet.querySelector('[data-snowman-paypal]');
    if (button) button.hidden = false;
  };
  const open = async ({ root, form }) => {
    const wallet = root.querySelector('[data-snowman-wallet]');
    const target = new URL(wallet?.dataset.checkoutUrl || form?.dataset.checkoutUrl || '/checkout', location.href);
    if (target.origin !== location.origin || target.pathname !== '/checkout') throw new Error('The secure Shopify checkout address could not be verified.');
    const status = wallet?.querySelector('[data-wallet-status]');
    if (status) status.textContent = 'Your personalization is saved. Opening Shopify secure checkout…';
    location.assign(target.href);
  };
  globalThis.HeirloomSnowmanWallet = { open, reset };
  document.querySelectorAll('[data-snowman-product]').forEach(root => {
    const form = root.querySelector('[data-snowman-form]');
    form?.addEventListener('input', () => reset(root));
    form?.addEventListener('click', event => { if (event.target.closest('[data-snowman-count]')) reset(root); });
    window.addEventListener('pageshow', () => reset(root));
  });
  document.dispatchEvent(new Event('snowman-wallet-ready'));
})();
